var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 12.5,
    height: 12.5,
    rx: 6.25,
    stroke: "#373737",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3297_799",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 9,
    height: 9
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.16602,
    y: 2.16797,
    width: 8.66667,
    height: 8.66667,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3297_799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.49922 4.69375C6.36079 4.69375 6.24494 4.64711 6.15165 4.55382C6.05836 4.46053 6.01172 4.34468 6.01172 4.20625C6.01172 4.06782 6.05836 3.95197 6.15165 3.85868C6.24494 3.76539 6.36079 3.71875 6.49922 3.71875C6.63764 3.71875 6.7535 3.76539 6.84679 3.85868C6.94008 3.95197 6.98672 4.06782 6.98672 4.20625C6.98672 4.34468 6.94008 4.46053 6.84679 4.55382C6.7535 4.64711 6.63764 4.69375 6.49922 4.69375ZM6.19227 9.27986V5.77708H6.80616V9.27986H6.19227Z",
    fill: "#373737"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.87cb40206d413a3a83ca9ef0c7d93db7.svg";
export { ForwardRef as ReactComponent };